const QueryParams = Object.freeze({
  TAB: 'tab',
  REDIRECT_URL: 'redirectUrl',
});

/**
 * URLFormatter is responsible to parse any URL and get or set query params
 */
class URLFormatter {
  private location: string;
  private queryParams: URLSearchParams;

  constructor(url: string) {
    const HrefWithQueryParams = url.split('?');
    this.queryParams =
      HrefWithQueryParams.length === 2
        ? new URLSearchParams(HrefWithQueryParams[1])
        : new URLSearchParams();
    this.location = HrefWithQueryParams[0];
  }

  public setTab = (tabId: string): URLFormatter => {
    this.queryParams.set(QueryParams.TAB, tabId);
    return this;
  };

  public getTab = (): string | null => {
    return this.queryParams.get(QueryParams.TAB);
  };

  public getRedirectUrl = (): string | undefined => {
    const redirectUrl = this.queryParams.get(QueryParams.REDIRECT_URL);
    return redirectUrl ? decodeURIComponent(redirectUrl) : undefined;
  };

  public buildURLString = (): string => {
    return `${this.location}?${this.queryParams.toString()}`;
  };

  public getLocation = () => this.location;

  public getQueryParam = () => this.queryParams.toString();
}

export default URLFormatter;
